<template>
  <v-menu
    open-on-hover
    :open-delay="openDelay"
    :close-delay="closeDelay"
    location="bottom center"
    offset="8"
  >
    <template #activator="{ props }">
      <app-material-icon
        v-bind="props"
        :name="icon"
        :size="size"
        class="cursor-pointer ml-2"
      />
    </template>

    <v-card class="pa-4" :max-width="maxWidth">
      <slot />
    </v-card>
  </v-menu>
</template>

<script lang="ts" setup>
import type { AppIconSize } from '@/design-system/icons/AppMaterialIcon.vue'

const props = defineProps<{
  icon?: string
  size?: AppIconSize
  maxWidth?: number | string
  openDelay?: number
  closeDelay?: number
}>()

const {
  icon = 'info',
  size = 'sm',
  maxWidth = 340,
  openDelay = 80,
  closeDelay = 150,
} = props
</script>
